import { apiClient } from '@/api/client';
import { Category } from '@/api/models';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { DashboardLayout } from '@/components/layout/DashboardLayout';
import { useEntityDrawer } from '@/hooks/useEntityDrawer';
import { queryKeys } from '@/lib/queryKeys';
import { CategoryFormData } from '@/pages/categories/hooks/useCategoryMutations';
import * as React from 'react';
import { CategoriesList } from './components/CategoriesList';
import { CategoryDrawer } from './components/CategoryDrawer/index';
import { useCategoryMutations } from './hooks/useCategoryMutations';

export const CategoriesPage: React.FC = () => {
  const { state, actions } = useEntityDrawer<Category>({
    basePath: '/categories',
    queryKey: queryKeys.ADMIN_CATEGORIES,
    fetchFn: async (id: number) => {
      const response = await apiClient.GET('/admin/categories/{id}', {
        params: { path: { id } },
      });
      if (response.error) throw new Error('Failed to fetch category');
      return response.data as Category;
    },
    supportsCreate: true,
  });

  const {
    actions: mutationActions,
    isFormLoading,
    isDeleting,
  } = useCategoryMutations();

  const handleFormSubmit = async (formData: CategoryFormData) => {
    await mutationActions.handleFormSubmit(formData, state.mode, state.entity);
  };

  return (
    <DashboardLayout>
      <ProtectedRoute action='read' subject='Category'>
        <CategoriesList
          onRowClick={category => actions.open(category.id!)}
          onEditCategory={category => actions.edit(category.id!)}
          onDeleteCategory={mutationActions.handleDelete}
          onCreateCategory={actions.create}
          isDeleting={isDeleting}
        />

        <CategoryDrawer
          onFormSubmit={handleFormSubmit}
          onDeleteCategory={mutationActions.handleDelete}
          isFormLoading={isFormLoading}
        />
      </ProtectedRoute>
    </DashboardLayout>
  );
};
